import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePersonalProfile } from '../entities/usePersonalProfile';
import { usePrimaryLockbox } from '../treasury/usePrimaryLockbox';
import { useActivityEvent } from '../activity/useActivityEvent';

export function useNewTradeAsActivityEvent({
  profileId,
  lockboxId,
  recipient,
  sendInstrument,
  receiveInstrument,
  memo,
  isConfirming,
}) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const primaryLockbox = usePrimaryLockbox(profileId);
  lockboxId = lockboxId || primaryLockbox?.id;

  const lockboxes = useQuery(tokenizedApi.treasury.lockboxesQuery())?.data;

  const activityEvent =
    tokenizedApi.transfers.makeActivityEventForUnconfirmedTrade({
      profileId,
      lockboxId,
      recipient,
      sendInstrument,
      receiveInstrument,
      memo,
      isConfirming,
      lockboxes,
      ownHandle: personalProfile?.handle,
    });

  return useActivityEvent(activityEvent);
}
